import React from "react";
import InputNumber from "./input-number";
import InputText from "./input-text";
import InputMultiEmail from "./input-multi-email";
import InputKeyGenerator from "./input-key-generator";
import InputDropdown from "./input-dropdown";
import store from "src/store";
import useIsLoggedIn from "src/utils/use-is-logged-in";

export default function EngagementForm(props) {
    const { userInfo } = useIsLoggedIn();

    const getUserOrganisationList = () => {
        if (store.userOrganizations.length) {
            return store.userOrganizations.map((item) => {
                return {
                    label: item.name,
                    value: item._id
                }
            });
        } else {
            return [];
        }
    }

    return (
        <>
            <form>
                {
                    !userInfo?.auth0Subscripton &&
                    <div css="margin-top: 15px;">
                        <InputDropdown
                            id={"orgId"}
                            label={"Organization"}
                            value={props.orgId}
                            disabled={false}
                            showClearOption={false}
                            onChange={(value) => { props.setOrgId(value) }}
                            list={getUserOrganisationList()}
                            showOutsideLabel = {true}
                            hasError={props.orgIdHasError}
                            errorText={props.orgIdErrorText}
                        />
                    </div>
                }
                <div css="margin-top: 15px;">
                    <InputText
                        id={"engId"}
                        label={"Engagement id"}
                        value={props.engId}
                        disabled={false}
                        onChange={(value) => { props.setEngId(value) }}
                        hasError={props.engIdHasError}
                        errorText={props.engIdErrorText}
                    />
                </div>
                <div css="margin-top: 15px;">
                    <InputKeyGenerator
                        id={"apiKey"}
                        label={"API Key"}
                        value={props.API_KEY}
                        readOnly={true}
                        onChange={(value) => { props.setAPI_KEY(value) }}
                    />
                </div>
                <div css="margin-top: 15px;">
                    <InputNumber
                        id={"maxAllowedVersion"}
                        fullWidth={true}
                        label={"Max allowed version"}
                        value={props.maxAllowedVersion}
                        allowDecimal={false}
                        onChange={(value) => { props.setMaxAllowedVersion(value) }}
                        hasError={props.maxAllowedVersionHasError}
                        errorText={props.maxAllowedVersionErrorText}
                    />
                </div>
                {
                    !userInfo?.auth0Subscripton &&
                    <div css="margin-top: 15px;">
                        <InputMultiEmail
                            id={"emailList"}
                            label={"Add email"}
                            value={props.allowedEmails}
                            onChange={(value) => { props.setAllowedEmails(value) }}
                        />
                    </div>
                }
            </form>
        </>
    )
}